import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import RichText from "@/components/RichText";
import { Reveal, PrimaryButton } from "@/components/primitives";
import Snippet from "@/components/Snippet";
import { useSite } from "@/context/SiteContext";
import { LIB } from "@/data/content";

export default function FAQ() {
  const { page, img } = useSite();
  const p = page("faq");

  return (
    <div>
      <PageHero {...p.hero} image={img("faq_hero", LIB.lavenderHeather)} imageAlt="Delicate lavender blooms catching soft light" />

      <section className="py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal><RichText html={p.body_html} /></Reveal>

          <Reveal delay={0.1}>
            <div className="mt-14 text-center rounded-3xl border border-brand-line bg-brand-lavender-soft/50 p-10">
              <h3 className="font-heading text-2xl text-brand-ink mb-3"><Snippet k="faq.cta_heading" fallback="Still have a question?" /></h3>
              <p className="font-body text-brand-slate mb-6"><Snippet k="faq.cta_text" fallback="Isabelle would be glad to hear from you." /></p>
              <PrimaryButton as={Link} to="/contact" data-testid="faq-contact-btn">
                <Snippet k="faq.cta_btn" fallback="Get in touch" /> <ArrowRight size={18} strokeWidth={1.5} />
              </PrimaryButton>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
